/**
 * Конвертирует градусы в радианы.
 * @param deg - Угол в градусах.
 * @returns Угол в радианах.
 */
function deg2rad(deg: number): number {
  return deg * (Math.PI / 180);
}

/**
 * Рассчитывает расстояние между двумя географическими точками по формуле Хаверсина.
 * @param lat1 - Широта первой точки.
 * @param lon1 - Долгота первой точки.
 * @param lat2 - Широта второй точки.
 * @param lon2 - Долгота второй точки.
 * @returns Расстояние в километрах.
 */
export function getDistance(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
): number {
  const R = 6371; // Радиус Земли в км
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;
  return distance;
}
